import React from 'react';
import { Card, CardHeader, IconButton, Grid, useTheme } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Label } from '../../modules/modules.interface';
import { CustomTrans } from '../../../../../../translation/CustomTrans';
import { useCustomTranslation } from '../../../../../../translation/customTranslation';
import { Chips } from '../../../../../../components/chips/chips';

interface InstructionsProps {
  instructions: Label[];
}

export function Instructions({ instructions }: InstructionsProps) {
  const { t } = useCustomTranslation('assessment');
  const theme = useTheme();

  const getBadgeProps = (instruction: Label): any => {
    let color: any = 'basic';
    let label = '';
    const size = 'small';
    if (instruction?.audience === 'assessor') {
      label = t('ID_INSTRUCTIONS_FOR_ASSESSOR');
      color = 'default';
    }
    if (instruction?.audience === 'patient') {
      label = t('ID_INSTRUCTIONS_FOR_PATIENT');
      color = 'info';
    }
    return { label, color, size };
  };

  return (
    <Grid>
      {instructions.length > 0 && (
        <Card elevation={0}>
          <CardHeader
            title={t('ID_INSTRUCTIONS_HEADING')}
            titleTypographyProps={{
              variant: 'h6',
            }}
            action={
              // <IconButton>
              <HelpOutlineIcon
                fontSize="medium"
                sx={{ fill: theme.palette.text.primary }}
              />
              // </IconButton>
            }
            sx={{ p: 1, my: 2 }}
          />

          {instructions.map((instruction: Label) => {
            const badgeProps: any = getBadgeProps(instruction);
            return (
              <Grid sx={{ my: 2 }} key={instruction.key}>
                <Chips
                  label={badgeProps.label}
                  variant="filled"
                  color={badgeProps.color}
                  size={badgeProps.size}
                />
                <CustomTrans i18nKey={instruction.key} namespace="assessment" />
              </Grid>
            );
          })}
        </Card>
      )}
    </Grid>
  );
}
